const $ = require("jquery");
const Backbone = require("backbone");
const Handlebars = require("handlebars");
const resultTemplate = require("./../../templates/search/result.hbs");
const resultsTemplate = require("./../../templates/search/results.hbs");
const formTemplate = require("./../../templates/search/form.hbs");

export default Backbone.View.extend({
  events: {
    "submit [data-search-ajax-form]": "submit",
    "click [data-more-search-ajax-results-bottom-button]": "clickedMore",
    "click [data-clear-search-button]": "clickedClear",
    "focusout [data-search-input]": "removeAccentColor",
    "focusin [data-search-input]": "applyAccentColor"
  },

  initialize: function() {
    this.openInNewTab = this.$el.data("openInNewTab");

    const placeholder = this.$el.data("placeholder");
    const section = this.$el.data("section");
    const content = formTemplate({
      placeholder: placeholder,
      section: section
    });
    this.$el.append(content);
    this.removeAccentColor();
  },

  submit: function(e) {
    e.preventDefault();
    const data = this.$el.find("[data-search-ajax-form]").serialize(),
      url = this.$el.find("[data-search-ajax-form]").attr("action"),
      searchResultsContainer = this.$el.find("[data-search-results-container]");

    if (searchResultsContainer.length > 0) {
      searchResultsContainer.remove();
    }
    this.ajax(url, data);
  },

  clickedClear: function() {
    const searchResultsContainer = this.$el.find(
      "[data-search-results-container]"
    );
    if (searchResultsContainer.length > 0) {
      searchResultsContainer.remove();
    }
  },

  ajax: function(url, data) {
    $.ajax({
      url: url + "?" + data,
      cache: false,
      context: this,
      contentType: "application/json"
    }).done(this.response.bind(this));
  },

  response: function(data, status, response) {
    const currentPage = Number(response.getResponseHeader("x-current-page")),
      resultsCount = Number(response.getResponseHeader("x-results-count")),
      searchResultsContainer = this.$el.find("[data-search-results-container]");

    if (searchResultsContainer.length === 0) {
      this.responseFirstPage(resultsCount);
    }

    const lastPage = Number(response.getResponseHeader("x-last-page")),
      resultsContainer = $("[data-search-ajax-results]"),
      moreBtn = this.$el.find("[data-more-search-ajax-results-bottom-section]");

    for (let res of data) {
      res.openInNewTab = this.openInNewTab;
      const content = resultTemplate(res);
      resultsContainer.append(content);
    }

    if (lastPage > currentPage) {
      moreBtn.show();
      moreBtn.attr("data-next-page", currentPage + 1);
    } else {
      moreBtn.hide();
    }
  },

  responseFirstPage: function(totalCount) {
    const content = resultsTemplate({ totalCount: totalCount });
    this.$el.find("[data-search-ajax-main-content]").append(content);
    this.$el.find("[data-more-search-ajax-results-bottom-section]").hide();
  },

  clickedMore: function(e) {
    e.preventDefault();
    const data = this.$el.find("[data-search-ajax-form]").serialize(),
      url = this.$el.find("[data-search-ajax-form]").attr("action"),
      nextPage = this.$el.find("[data-next-page]").attr("data-next-page");
    this.ajax(url, data + "&page=" + nextPage);
  },

  removeAccentColor: function(ev) {
    if (this.$el.find("[data-search-input]").val() == "") {
      this.$el
        .find("[data-search-input-wrapper]")
        .removeClass("accent-color--border");
      this.$el
        .find("[data-search-glass-icon]")
        .removeClass("accent-color");
    }
  },

  applyAccentColor: function(ev) {
    this.$el
      .find("[data-search-input-wrapper]")
      .addClass("accent-color--border");
    this.$el.find("[data-search-glass-icon]").addClass("accent-color");
  }
});
